import { useSubscribeStores } from "../../stores/SubscribeStores";
import React from "react";

export function ProductList() {
  const {
    products,
    selectProduct,
    selectProductId,
    currentTab,
    isSubscription,
  } = useSubscribeStores((state) => ({
    products: state.products,
    selectProduct: state.selectProduct,
    selectProductId: state.selectProductId,
    currentTab: state.currentTab,
    isSubscription: state.isSubscription,
  }));

  return (
    <div className="mt-0 w-full pl-[5%] pr-[5%] lg:w-[60%] lg:pl-[0%] lg:pr-[0%]">
      {products.map((item) => {
        const selected = item.id === selectProductId;
        const isYearly = currentTab === "yearly";

        return (
          <div
            key={item.id}
            onClick={() => selectProduct(item)}
            className={`relative flex mt-6 flex-row justify-between w-full cursor-pointer transition-all duration-200 rounded-xl p-4 border-2 ${
              selected
                ? "border-[#7E57C2] bg-[#2D3139]/50"
                : "border-[#2D3139] bg-transparent hover:border-gray-700"
            }`}
          >
            <div className="flex flex-col justify-center">
              <div className="text-white font-bold text-[20px]">
                {item.name}
              </div>
              {isSubscription && isYearly && item.price_per_month && (
                <div className="text-white/60 text-[14px] font-medium mt-1">
                  ${item.price_per_month}/mo
                </div>
              )}
            </div>

            <div className="flex flex-row items-baseline pr-2">
              {isSubscription && isYearly && (
                <div className="text-white/40 text-[16px] line-through mr-2">
                  ${item.origin_amount}
                </div>
              )}
              <div className="text-white font-bold text-[24px]">
                ${item.amount}
              </div>
              {isSubscription && (
                <div className="text-white/70 text-[14px] ml-1">
                  {isYearly ? "/yr" : "/mo"}
                </div>
              )}
            </div>

            {item.discount_label &&
              item.discount_label !== "0% off" &&
              !item.discount_label.startsWith("Save") && (
                <div className="absolute top-[-12px] left-4 bg-[#FF4D4D] h-[22px] rounded-full text-white text-[12px] font-bold px-3 flex items-center shadow-lg">
                  {item.discount_label}
                </div>
              )}
            {/* 特殊处理年度折扣标签 */}
            {isSubscription && isYearly && (
              <div className="absolute top-[-12px] left-4 bg-[#FF4D4D] h-[22px] rounded-full text-white text-[12px] font-bold px-3 flex items-center shadow-lg">
                30% off
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
